import { Autocomplete, Checkbox, Chip, Grid, TextField } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  getParams,
  navigate,
  sendPatchRequest,
  sendPostRequest,
  sendGetRequest,
  allowedOperations,
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import EasyTextEdit from "./component/text-edit";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const showRef = {
  name: "",
  code: "",
  seasons: "",
  episodes: "",
  segments: [],
};

const ShowEdit = () => {
  const { uuid } = getParams();
  var [show, setshow] = useState(showRef);
  const { canCreate } = allowedOperations();
  const [segments, setSegments] = useState([]);

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
  });

  const fetchInfo = () => {
    setStatus({ ...{ loading: true } });
    Promise.all([
      sendGetRequest(`shows?uuid=${uuid}`),
      sendGetRequest(`segments`),
    ]).then(([show, segments]) => {
      if (show) {
        show.segments = show.segments.map((segment) => segment.uuid);
        setshow({ ...showRef, ...show });
      }
      setSegments(segments || []);
      setStatus({ ...{ loading: false } });
    });
  };

  useEffect(() => {
    fetchInfo();
    return () => setshow(showRef);
    // eslint-disable-next-line
  }, [uuid]);

  const createUpdateshow = () => {
    if (uuid) {
      sendPatchRequest(
        `shows/${uuid}`,
        { ...show, uuid },
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        },
      );
    } else {
      sendPostRequest(
        "shows",
        show,
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        },
      );
    }
  };

  const onValueChange = (value, tag) => {
    setshow({ ...show, [tag]: value });
  };

  return (
    <EditPage
      title={uuid ? "Edit Show" : "Add Show"}
      status={status}
      btnLabel={canCreate ? (uuid ? "Update Now" : "Add Now") : null}
      onSave={() => createUpdateshow()}
      onBack={() => navigate(`${AppRoutes.shows}`, true)}
      validated={
        show.name &&
        show.code &&
        show.seasons &&
        show.episodes &&
        show.segments.length >= 0 &&
        !status.loading
      }
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          setshow({ ...showRef });
          navigate(`${AppRoutes.shows}`, true);
        }
      }}
    >
      <Grid item md={3} xs={12}>
        <EasyTextEdit
          label="Show name"
          placeholder="i.e Ubongo Kids"
          type="text"
          id="name"
          errorText=""
          textField={true}
          disabled={status.loading}
          value={show.name}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={2} xs={12}>
        <EasyTextEdit
          label="Show Code"
          placeholder="i.e UK"
          type="text"
          id="code"
          errorText=""
          textField={true}
          disabled={status.loading}
          value={show.code}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={2} xs={12}>
        <EasyTextEdit
          placeholder="Show Seasons"
          label="Number of Seasons"
          type="number"
          id="seasons"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={show.seasons}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={2} xs={12}>
        <EasyTextEdit
          placeholder="Show Episodes"
          label="Number of Episodes"
          type="number"
          id="episodes"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={show.episodes}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={3} xs={12}>
        <Autocomplete
          multiple={true}
          id="segments"
          disableCloseOnSelect
          limitTags={2}
          disabled={status.loading}
          value={segments
            .filter((segment) => show.segments.includes(segment.uuid))
            .map((segment) => segment.name)}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="filled"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </li>
          )}
          options={segments.map((option) => option.name)}
          renderInput={(params) => <TextField {...params} label="Segments" />}
          onChange={(event, value) => {
            setshow({
              ...show,
              segments: segments
                .filter((segment) => value.includes(segment.name))
                .map((segment) => segment.uuid),
            });
          }}
        />
      </Grid>
    </EditPage>
  );
};

export default ShowEdit;
